"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// import { useSelector } from 'react-redux'
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var hero_image_v3_svg_1 = __importDefault(require("@assets/components/home/rotating-links-graphic/hero-image-v3.svg"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        heroContainer: (_a = {
                position: 'relative',
                width: '100%',
                maxWidth: function (props) { return props.targetImageWidthPx + "px"; },
                height: function (props) { return props.heightToWidthRatio * 100 + "vw"; },
                maxHeight: function (props) {
                    return props.targetImageWidthPx * props.heightToWidthRatio + "px";
                },
                marginLeft: '0',
                marginRight: '-1.5px',
                marginBottom: function (props) {
                    return "max(" + props.linkBoxHeightToImageWidth * -50 + "vw, calc((" + -1 * props.linkBoxHeightToImageWidth * props.targetImageWidthPx + "px / 2)))";
                },
                '@media screen\\0': {
                    marginBottom: function (props) {
                        return "calc((" + -1 * props.linkBoxHeightToImageWidth * props.targetImageWidthPx + "px / 2))";
                    },
                }
            },
            _a[theme.breakpoints.down('md')] = {
                margin: 'auto',
            },
            _a),
        heroImage: {
            position: 'absolute',
            width: '100%',
            maxWidth: function (props) { return props.targetImageWidthPx + "px"; },
            height: function (props) { return props.heightToWidthRatio * 100 + "vw"; },
            maxHeight: function (props) {
                return props.targetImageWidthPx * props.heightToWidthRatio + "px";
            },
            verticalAlign: 'top',
            left: 0,
            bottom: 0,
        },
        rotatingLinks: {
            position: 'absolute',
            width: function (props) { return props.linkBoxWidthToImageWidth * 100 + "vw"; },
            maxWidth: function (props) {
                return props.linkBoxWidthToImageWidth * props.targetImageWidthPx + "px";
            },
            height: function (props) {
                return props.linkBoxHeightToImageWidth * 100 + "vw";
            },
            maxHeight: function (props) {
                return props.linkBoxHeightToImageWidth * props.targetImageWidthPx + "px";
            },
            fontSize: 'min(3.25vw, 26px)',
            fontWeight: 400,
            color: theme.palette.secondary.contrastText,
            opacity: 0.7,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: function (props) {
                return props.linkBoxWidthToImageWidth *
                    props.rotatingLinkLeftMarginToLinkBox *
                    100 + "vw";
            },
            '@media screen\\0': {
                fontSize: '26px',
            },
        },
    });
});
var RotatingLinksGraphic = function () {
    var t = react_i18next_1.useTranslation().t;
    var theme = core_1.useTheme();
    var isMediumWidth = core_1.useMediaQuery(theme.breakpoints.up('md'));
    var classes = useStyles({
        heightToWidthRatio: 617.63 / 693.3,
        linkBoxWidthToImageWidth: 662.01 / 693.3,
        linkBoxHeightToImageWidth: 98.0139235 / 693.3,
        rotatingLinkLeftMarginToLinkBox: 3.5 / 100,
        // Specifies max width of the graphic in px.
        targetImageWidthPx: isMediumWidth ? 693.3 : 313,
    });
    // const linksToRotate = useSelector(
    //   (state: GoGovReduxState) => state.home.linksToRotate,
    // )
    return (react_1.default.createElement("div", { className: classes.heroContainer },
        react_1.default.createElement("img", { className: classes.heroImage, src: hero_image_v3_svg_1.default, alt: t('general.appTitle') })));
};
exports.default = RotatingLinksGraphic;
